/**
 * Created by Administrator on 2017/6/19.
 */

import DEV from './dev_config'
import PROD from './prod_config'

let config;
if(process.env.NODE_ENV == 'production') {
  config = PROD
} else if(process.env.NODE_ENV == 'development') {
  config = DEV
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js